import { render, staticRenderFns } from "./SelectApprovers.vue?vue&type=template&id=806cbdb2"
import script from "./SelectApprovers.vue?vue&type=script&lang=js"
export * from "./SelectApprovers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports